import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Auth, authState } from '@angular/fire/auth';
import { inject } from '@angular/core';
import { Observable, from, firstValueFrom } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

export const authTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const auth = inject(Auth);

  return from(getIdToken(auth)).pipe(
    switchMap((token) => {
      const baseHeaders: Record<string, string> = {
        'X-App-Id': 'admin-apps',
      };

      if (!token) {
        return next(
          req.clone({
            setHeaders: baseHeaders,
          })
        );
      }

      const authReq = req.clone({
        setHeaders: {
          ...baseHeaders,
          Authorization: `Bearer ${token}`,
        },
      });

      return next(authReq);
    })
  );
};

async function getIdToken(auth: Auth): Promise<string | null> {
  const currentUser = auth.currentUser;
  if (currentUser) {
    return currentUser.getIdToken();
  }

  const user = await firstValueFrom(authState(auth).pipe(take(1)));
  return user ? user.getIdToken() : null;
}
